"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toPoundsPence = void 0;
/**
 * Makes sure that any money amounts are rounded to 2dp (even if might be stored with 0 or 1dp)
 * @param amount
 */
const toPoundsPence = (amount) => {
    return parseFloat(amount.toFixed(2));
};
exports.toPoundsPence = toPoundsPence;
exports.default = {
    toPoundsPence: exports.toPoundsPence
};
//# sourceMappingURL=moneyUtil.js.map